import * as AF from "src/types/formTemplate";
import { z } from "zod";

export const FormikSchema = z
  .object({
    type: z.string() as z.ZodType<AF.V3.QuestionType>,
    customQuestionTypeId: z.string().uuid().optional(),
  })
  .superRefine(({ customQuestionTypeId, type }, ctx) => {
    if (type === AF.V3.QuestionTypes.CustomQuestion && !customQuestionTypeId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Custom question type is required",
      });
    }
  });

export function toFormValue(question: AF.V3.Question): FormikType {
  return {
    type: question.type,
    customQuestionTypeId:
      question.type === "CustomQuestion"
        ? question.customQuestionTypeId
        : undefined,
  };
}

export type FormikType = z.infer<typeof FormikSchema>;
